/**
 * Created by Jerker Nord on 2016-04-13.
 */

class MathHelper {


    /**
     * Maps value x in range inStart -> inEnd to range outStart -> outEnd.
     *
     * @param x Value to map to new range. x is a value in the in range.
     * @param inStart Start value in in range.
     * @param inEnd End value in in range.
     * @param outStart Start value in out range.
     * @param outEnd   End value in out range.
     * @returns {number}
     */
    static map(x:number, inStart:number, inEnd:number, outStart:number, outEnd:number):number {
        return (x - inStart) * (outEnd - outStart) / (inEnd - inStart) + outStart;
    }

    /**
     * Returns angle between two points in radians.
     * @param p1 first point
     * @param p2 second point
     * @returns {number} Angle
     */
    static angleBetweenPoints(p1:PIXI.Point, p2:PIXI.Point) {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
    }

    static addPoints(p1:PIXI.Point, p2:PIXI.Point):PIXI.Point {
        return new PIXI.Point(p1.x + p2.x, p1.y + p2.y);
    }

    static subPoints(p1:PIXI.Point, p2:PIXI.Point):PIXI.Point {
        return new PIXI.Point(p1.x - p2.x, p1.y - p2.y);
    }

    static multiplyPoints(p1:PIXI.Point, p2:PIXI.Point):PIXI.Point {
        return new PIXI.Point(p1.x * p2.x, p1.y * p2.y);
    }

    static dividePoints(p1:PIXI.Point, p2:PIXI.Point):PIXI.Point {
        return new PIXI.Point(p1.x / p2.x, p1.y / p2.y);
    }

    /**
     * A new PIXI.Point along a line defined by it's two end points
     * @param p1 first point
     * @param p2 second point
     * @param ratio The distance ratio from p1 to p2. Negative ratio is on the extended line before p1, ratio > 1 on
     *     extended line after p2. ratio > 0 && < 1 is on the line.
     * @returns {number} Distance
     */
    static pointAlongLine(p1:PIXI.Point, p2:PIXI.Point, ratio:number) {
        let t = ratio;
        return new PIXI.Point(((1 - t) * p1.x + t * p2.x), ((1 - t) * p1.y + t * p2.y));
    }

    /**
     * Returns distance between two points.
     * @param p1 first point
     * @param p2 second point
     * @returns {number} Distance
     */
    static distanceBetweenPoints(p1:PIXI.Point, p2:PIXI.Point) {
        return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
    }

    /**
     * Creates a random point within a rectangle.
     *
     * @param rect The rectangle to get random numbers within, including edge values.
     * @param mask A rectangle that functions as mask, masking of the area from the fist rectangle.
     * So random points within the mask will be recalculated and ignored. You can use this to a variety of shapes.
     * @returns {PIXI.Point} Random point
     */
    static randomPosInRect(rect:PIXI.Rectangle, mask?:PIXI.Rectangle):PIXI.Point {
        let randomPos:PIXI.Point = new PIXI.Point(MathHelper.randomIntFromInterval(rect.x, rect.width + rect.x), MathHelper.randomIntFromInterval(rect.y, rect.height + rect.y));

        let missed:number = 0;
        if(mask) {
            while(mask.contains(randomPos.x, randomPos.y)) {
                randomPos = new PIXI.Point(MathHelper.randomIntFromInterval(rect.x, rect.width + rect.x), MathHelper.randomIntFromInterval(rect.y, rect.height + rect.y));
                missed++; //Only used for debugging, to se how many times the function have to recalculate the random
                          // point.
            }
        }
        return randomPos;
    }

    /**
     * Constrains a number to be within a range.
     *
     * Returns
     * value: if x is between min and max
     * min: if x is less than min
     * max: if x is greater than max
     *
     * @param value The value you want to constrain
     * @param min the minimum return value
     * @param max the maximum return value
     * @returns {number}
     */
    static constrain(value:number, min:number, max:number):number {
        return Math.max(min, Math.min(value, max));
    }

    static randomNumberFromInterval(min:number, max:number):number {
        let randomNumber:number = min + (max - min) * Math.random();
        return Number(randomNumber.toFixed(2));
    }

    static randomIntFromInterval(min:number, max:number):number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    static roundToDecimals(num:number, noOfDecimals:number):number {
        return Number((num).toFixed(noOfDecimals));
    }


    static shuffleArray(array:any[]):any[] {
        let a:any[] = array.concat();
        for(let i = a.length; i; i--) {
            let j = Math.floor(Math.random() * i);
            [a[i - 1], a[j]] = [a[j], a[i - 1]];
        }
        return a;
    }
}

export {MathHelper};